"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const styled_components_1 = __importDefault(require("styled-components"));
const LabelItemWrapper_1 = require("../LabelItemWrapper");
function LabelItemCustom({ identifier, text, selectedLabelID, onSelectLabelID, }) {
    const isSelected = identifier === selectedLabelID;
    const onItemClick = (0, react_1.useCallback)(() => {
        onSelectLabelID(identifier);
    }, [identifier, onSelectLabelID]);
    return ((0, jsx_runtime_1.jsx)(LabelItemWrapper_1.LabelItemWrapper, { isSelected: isSelected, onClick: onItemClick, "data-e2e": 'LabelItemCustom_LabelItemWrapper', children: (0, jsx_runtime_1.jsx)(Text, { isSelected: isSelected, "data-e2e": 'LabelItemCustom_Text', children: text }) }, `${identifier}-${selectedLabelID}`));
}
exports.default = (0, react_1.memo)(LabelItemCustom);
const Text = styled_components_1.default.div `
  line-height: 24px;
  padding: 0 8px;
  font-weight: ${({ isSelected }) => (isSelected ? 700 : 400)};
`;
